import { RemoteAuth } from '../../../data/usecases/auth/auth'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory-no-redirect'

export const makeRemoteMe = (): any => new RemoteAuth('/usuario/me', makeAxiosHttpClient())

export const makeRemoteSignIn = (): any => new RemoteAuth('/autenticacao/login', makeAxiosHttpClient())

export const makeRemotePasswordRecovery = (): any => new RemoteAuth('/usuario/recuperar-senha', makeAxiosHttpClient())

export const makeRemoteSignInAs = (): any => new RemoteAuth('/autenticacao/login/admin', makeAxiosHttpClient())
